<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <FormItem label="功能权限" prop="permission">
        <div class="permission-wrap">
          <Alert show-icon>决定用户可以看到哪些页面和哪些操作</Alert>
          <div class="permission-content">
            <div class="item" v-for="(item, index) in apiData.permissionList" :key="index">
              <Tree
                  :ref="`ref${index}`"
                  :data="[item]"
                  show-checkbox
                ></Tree>
            </div>
          </div>
        </div>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button style="width: 90px" @click="$router.go(-1)">取消</Button>
  </div>
</template>

<script>
import * as apiPermission from '@/api/company/permission'
import { apiOrganizationDetail } from '@/api/organization'
import { Tree } from 'view-design'
export default {
  name: 'add-form',
  data () {
    return {
      Tree,
      query: {},
      search: {},
      diyDom: {},
      // 表单数据
      form: {
        permission: []
      },
      diyData: {
        rules: {}
      },
      apiData: {
        permissionList: []
      }
    }
  },
  computed: {},
  methods: {
    // 获取详情
    getDetail () {
      apiOrganizationDetail(this.query.id).then(res => {
        this.form.permission = res.permission_id
        this.selectAuth(res.permission_id, this.apiData.permissionList)
      })
    },
    // 获取权限列表
    getPermissionList () {
      this.$store.commit('setSpinShow', true)
      apiPermission
        .apiPermissionMenu()
        .then(res => {
          this.apiData.permissionList = res.map(item => {
            return {
              ...item,
              value: []
            }
          })
          this.getDetail()
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    // 回填树选中项
    selectAuth (menus, arr) {
      arr.forEach((item, index) => {
        if (menus.includes(item.id)) {
          this.$set(arr[index], 'checked', true)
        }
        if (item.children && item.children.length > 0) {
          this.$set(arr[index], 'checked', false)
          this.selectAuth(menus, item.children)
        }
      })
      // menus.forEach(item => {
      //   arr.forEach((citem, cindex) => {
      //     if (citem.id == item) {
      //       this.$set(arr[cindex], 'checked', true)
      //     }
      //     if (citem.children && citem.children.length > 0) {
      //       // 如果存在子菜单，把父菜单选择为空，不然会全部选择上，在提交的时候，用数组去重
      //       this.$set(arr[cindex], 'checked', false)
      //       this.selectAuth(menus, citem.children)
      //     }
      //   })
      // })
    },
    submit () {
      // 获取树id权限集合
      this.form.permission = []
      this.apiData.permissionList.forEach((item, index) => {
        this.$refs[`ref${index}`][0].getCheckedNodes().forEach(citem => {
          this.form.permission.push(citem.id)
        })
      })
      // 数组去重
      setTimeout(() => {
        this.form.permission = [...new Set([...this.form.permission, ...this.form.permission])].sort()
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            const opt = {
              permissions: this.form.permission
            }
            if (this.query.id) {
              opt.id = this.query.id
              this.$store.commit('setSpinShow', true)
              apiPermission
                .apiPermissionCompany(opt)
                .then(res => {
                  this.$Message.success('企业授权成功')
                  this.$router.go(-1)
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            }
          }
        })
      }, 100)
    }
  },
  mounted () {
    this.query = this.$route.query
    this.getPermissionList()
  }
}
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
    .permission-wrap {
      padding: 10px 20px;
      border: 1px solid #ededed;
      .permission-content {
        display: flex;
        .item {
          width: 25%;
        }
      }
    }
  }
</style>
